import { forwardRef } from 'react';
import { InfoCircleIcon } from './icons.tsx';
import { formatRRN } from '@/utils';
import styles from './RrnInput.module.css';

interface Props {
  id: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  autoComplete?: string;
}

/**
 * A self-contained RRN (rijksregisternummer) field: label, formatted input, and
 * optional inline error message.  Both SubjectModal and Profile use this.
 */
export const RrnInput = forwardRef<HTMLInputElement, Props>(function RrnInput(
  { id, value, onChange, error, autoComplete = 'off' },
  ref,
) {
  return (
    <div className="field-group">
      <label className="field-label" htmlFor={id}>
        Rijksregisternummer
        <span className={`text-muted ${styles.hint}`}>(formaat: JJ.MM.DD-SSS-CC)</span>
      </label>
      <input
        ref={ref}
        id={id}
        type="text"
        className={error ? 'field-input field-input-error' : 'field-input'}
        value={value}
        onChange={(e) => onChange(formatRRN(e.target.value))}
        placeholder="00.00.00-000-00"
        maxLength={15}
        autoComplete={autoComplete}
      />
      {error && (
        <div className={styles.errorMsg} role="alert">
          <InfoCircleIcon size={18} className={styles.errorIcon} />
          <span className={styles.errorText}>{error}</span>
        </div>
      )}
    </div>
  );
});
